"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Loader - Use this to wrap around any component to show loader
 */
var Loader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Loader, _React$Component);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loader).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tip = _this$props.tip,
          loading = _this$props.loading,
          className = _this$props.className,
          loaderClassName = _this$props.loaderClassName,
          overlay = _this$props.overlay,
          props = _objectWithoutProperties(_this$props, ["tip", "loading", "className", "loaderClassName", "overlay"]);

      var loaderMsg;

      if (tip) {
        loaderMsg = _react.default.createElement(_TextLabel.default, {
          className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-loader-tip"),
          type: "secondary"
        }, tip);
      }

      var loader;

      if (loading) {
        var styleClass;

        if (this.props.children || overlay) {
          styleClass = 'overlay-loader';
        }

        loader = _react.default.createElement("div", {
          className: styleClass
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)('donut-loader', loaderClassName)
        }), loaderMsg);
      }

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var styleProps = {
        'data-overlay': overlay
      };
      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-loader"), className)
      }, styleProps, props), loader, this.props.children);
    }
  }]);

  return Loader;
}(_react.default.Component);

exports.default = Loader;
Loader.propTypes = {
  /**
   * Add custom classname.
   */
  className: _propTypes.default.string,

  /**
   * Can be a combination of any of the following strings:
   * -blue : blue color loader
   * -gray : gray color loader
   * -large : large loader
   * -dark-inner : black color inside the loader
   *
   * TODO: This should be seperated into 3 different
   * properties.  color, size, and innerColor.
   */
  loaderClassName: _propTypes.default.string,

  /**
   * If children element is provide the loader will be overlay in the
   * center of the element.
   */
  children: _propTypes.default.node,

  /**
   * Show the spinner loader.
   */
  loading: _propTypes.default.bool,

  /**
   * Force overlay style.
   */
  overlay: _propTypes.default.bool,

  /**
   * String description.
   */
  tip: _propTypes.default.string
};
Loader.defaultProps = {
  loading: true
};